import { Card } from 'antd';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { TCar } from '../start-work-order/type';
import {
    EditOutlined,
    DeleteOutlined,
    FileImageOutlined,
} from '@ant-design/icons';
import { ICReportSearch } from '../../icons';

const Wrapper = styled.div`
    .ant-card-body {
        display: flex;
        flex-direction: column;
        padding: 16px;
    }
    .actions {
        position: absolute;
        right: 15px;
        top: 15px;
        .action-container {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;

type MobileListCarPageProps = {
    carList: TCar[];
    onViewImages: (licensePlate: string) => void;
    onViewServices?: (car: TCar) => void;
    onEditCar?: (car: TCar) => void;
    onDeleteCar?: (car: TCar) => void;
};

export const MobileListCarPage: React.FC<MobileListCarPageProps> = ({
    carList,
    onViewImages,
    onViewServices,
    onEditCar,
    onDeleteCar,
}) => {
    return (
        <Wrapper className="flex flex-col gap-[15px] px-1 mb-[80px] relative">
            {carList.map(car => {
                return (
                    <Card
                        key={car.carId}
                        className={classNames([
                            'relative flex flex-col cursor-pointer rounded-[12px] max-md:hover:ring-0 hover:ring-2 hover:ring-[var(--primaryColor)] shadow-card-shadow',
                        ])}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <div className="ml-2 flex gap-1 flex-col">
                                    <div className="text-lg font-bold text-high-em">
                                        {car.licensePlate}
                                    </div>
                                    <div className="text-sm text-low-em">
                                        {car.make} {car.model}
                                    </div>
                                    <div className="text-sm text-low-em">
                                        {car.year}
                                    </div>
                                </div>
                            </div>
                            <div className="flex actions gap-[15px]">
                                {onViewServices && (
                                    <div
                                        className="action-container gap-2 cursor-pointer shadow-big-shadow"
                                        onClick={() => {
                                            onViewServices(car);
                                        }}
                                    >
                                        <ICReportSearch
                                            width={18}
                                            height={18}
                                        />
                                    </div>
                                )}
                                <div
                                    className="action-container gap-2 cursor-pointer shadow-big-shadow"
                                    onClick={() => {
                                        onViewImages(car.licensePlate);
                                    }}
                                >
                                    <FileImageOutlined />
                                </div>
                                {onEditCar && (
                                    <div
                                        className="action-container gap-2 cursor-pointer shadow-big-shadow"
                                        onClick={() => {
                                            onEditCar(car);
                                        }}
                                    >
                                        <EditOutlined />
                                    </div>
                                )}
                                {onDeleteCar && (
                                    <div
                                        className="action-container bg-red-500 text-white cursor-pointer shadow-big-shadow"
                                        onClick={() => {
                                            onDeleteCar(car);
                                        }}
                                    >
                                        <DeleteOutlined />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                );
            })}
        </Wrapper>
    );
};
